export default __webpack_public_path__ + "static/CHS_Logo-016a5754f6f73ba3e0b0d4aa7679485c.png";